import { useState, useCallback } from "react";
import UserManagementManager from "../UserManagementManager";
import PoleService from "../../../services/PoleService";
import { userManagementProfiles } from "../../../shared/utils/enum";

export const userModal = {
  defaultValues: {
    adUser: "",
    profileId: "",
    licenseTypeId: "",
    licenseExpireDate: null,
    courseExpireDate: null,
    termsAcceptedAt: null
  }
};

const useCreateOrUpdateUser = (setValue, editableUserId, setSelectedPoles) => {
  const [loadingCreateOrUpdate, setLoadingCreateOrUpdate] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);
  const [userData, setUserData] = useState({});

  const getUserById = useCallback(
    async callback => {
      setLoadingUser(true);
      const data = await UserManagementManager.getUserById(editableUserId);
      if (data) {
        let currentPoles = [];
        if (data.profile?.profileId === userManagementProfiles.regionalFac.value) {
          try {
            const response = await PoleService.getPolosByUserId(editableUserId);
            if (response.data) {
              currentPoles = response.data.map(p => p.name);
            }
          } catch (error) {
            console.error("Erro ao buscar polos do usuário", error);
            currentPoles = data.poles?.map(p => p.name) || (data.pole ? [data.pole.name] : []);
          }
        } else {
          currentPoles = data.poles?.map(p => p.name) || (data.pole ? [data.pole.name] : []);
        }
        setSelectedPoles(currentPoles);
        callback(data, currentPoles);
      }
      setLoadingUser(false);
    },
    [editableUserId, setSelectedPoles]
  );

  const setSchemaValues = useCallback(
    async editableUser => {
      setValue("isEditable", true);
      setValue("adUser", editableUser.adUser);
      setValue("profileId", editableUser.profile?.profileId);
      setValue("licenseTypeId", editableUser.license?.licenseTypeId);
      setValue("licenseExpireDate", editableUser.license?.expireDate);
      setValue("courseExpireDate", editableUser.course?.expireDate);
      setValue("termsAcceptedAt", editableUser.termsAcceptedAt);
      setUserData(editableUser);
    },
    [setValue]
  );

  const checkIfDeletedCourseOrLicense = (data, oldData) => {
    const isDeletedLicense =
      (!!oldData.license.licenseTypeId && !data.licenseTypeId) ||
      (!!oldData.license.expireDate && !data.licenseExpireDate);
    const isDeletedCourse = !!oldData.course.expireDate && !data.courseExpireDate;
    return isDeletedLicense || isDeletedCourse;
  };

  const createOrUpdate = async (user, data, callBack) => {
    setLoadingCreateOrUpdate(true);

    const response = !!editableUserId
      ? await UserManagementManager.updateUser(user, editableUserId, data.reasonForEdit)
      : await UserManagementManager.createNewUser(user);

    if (response) callBack();

    setLoadingCreateOrUpdate(false);
  };

  const loadUserData = useCallback(
    async adUser => {
      setLoadingUser(true);

      const data = await UserManagementManager.getUserDataFromAd(adUser);

      if (data) {
        setUserData(data);
        if (data.poles && data.poles.length > 0) {
          setSelectedPoles(data.poles.map(p => p.name));
        } else if (data.pole) {
          setSelectedPoles([data.pole.name]);
        }
      } else {
        setUserData();
        setSelectedPoles([]);
      }

      setLoadingUser(false);
      return !!data;
    },
    [setSelectedPoles]
  );

  const resetUserData = useCallback(() => {
    setUserData();
  }, []);

  

  return {
    getUserById,
    createOrUpdate,
    loadingCreateOrUpdate,
    loadingUser,
    setSchemaValues,
    checkIfDeletedCourseOrLicense,
    userData,
    loadUserData,
    resetUserData
  };
};

export default useCreateOrUpdateUser;
